export default "__VITE_ASSET__C$BXLmRJ__"